<template>
    <div class="main-box">
        {{ Id }}
        <img src="../static/logo.png" alt="">
    </div>
</template>

<script>
    export default {
        // props:{
        //     Id: {
        //         type: String,
        //         default:""
        //     }
        // }
        data(){
            return {
                Id:""
            }
        },
        created(){
            this.Id = decodeURIComponent(this.$route.query.Id)
        }
    }
</script>

<style lang="scss" scoped>
    .main-box{
        height: 600px;
    }
</style>